import { createAsyncThunk, ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { AICodingClient, CreateAICodingJobCommand, GetAICodingVariableWithCodesRequest } from "app/ApiClient";
import { LoadingState } from "types";
import { AICodingState } from "./aiCodingState";

const client = new AICodingClient(process.env.REACT_APP_API_URL);


export const createAICodingJob = createAsyncThunk(
  "aiCoding/createAICodingJob",
  async (data: CreateAICodingJobCommand, { rejectWithValue }) => {
    try {
      return await client.createAICodingJob(data);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getVariableWithCodes = createAsyncThunk(
  "aiCoding/getVariableWithCodes",
  async (
    { projectId, version, aiCodingVariableWithCodesRequest }: { projectId: number; version: string; aiCodingVariableWithCodesRequest: GetAICodingVariableWithCodesRequest },
    { rejectWithValue },
  ) => {
    try {
      return await client.getAICodingVariableWithCodes(projectId, version, aiCodingVariableWithCodesRequest);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const addV1Reducers = (builder: ActionReducerMapBuilder<AICodingState>) => {
  builder
    .addCase(createAICodingJob.pending, (state) => {
      state.createAICodingJobState = LoadingState.pending;
    })
    .addCase(createAICodingJob.fulfilled, (state, action) => {
      state.createAICodingJobState = LoadingState.succeed;
      state.createdJobConfigId = action.payload.jobConfigId;
    })
    .addCase(createAICodingJob.rejected, (state) => {
      state.createAICodingJobState = LoadingState.failed;
    })
    .addCase(getVariableWithCodes.pending, (state) => {
      state.variableStatsLoading = LoadingState.pending;
    })
    .addCase(getVariableWithCodes.fulfilled, (state, action) => {
      state.variableStatsLoading = LoadingState.succeed;
      
      const payload = action.payload;

      if (!payload) {
        if (state.variableItemVM) {
          state.variableItemVM.stats = {
            total: 0,
            coded: 0,
            notCoded: 0,
          };
        }
        return;
      }

      const { totalResponses } = payload;
      if (state.variableItemVM) {
        state.variableItemVM.stats = {
          total: totalResponses ?? 0,
          coded: 0,
          notCoded: totalResponses ?? 0,
        };
        state.variableItemVM.variableLabelName = action.payload.battery;
      }
    })
    .addCase(getVariableWithCodes.rejected, (state) => {
      state.variableStatsLoading = LoadingState.failed;
    });
};
